import React from 'react'
import { Stack, Text, Avatar, Button, Flex } from '@mantine/core'
import pallabiHeadshot from '@/assets/images/pallabi-ellipse.png'
import marjoryHeadshot from '@/assets/images/marjory-ellipse.png'
import taylorHeadshot from '@/assets/images/taylor-ellipse.png'
import { formatPrice } from '@/lib/utilities'
import { STANDARD_CLINICAL_FEE } from '@/types/enums/lab-pricing-constants'

const clinicians = [
    { src: pallabiHeadshot, alt: 'Dr. Pallabi' },
    { src: marjoryHeadshot, alt: 'Dr. Marjory' },
    { src: taylorHeadshot, alt: 'Dr. Taylor' },
]

interface AboutLabPricingProps {
    onClose: () => void
    /** Clinical review fee in dollars (e.g. 15 or 30). Defaults to STANDARD_CLINICAL_FEE when not provided. */
    clinicalFee?: number
}

export function AboutLabPricing({ onClose, clinicalFee = STANDARD_CLINICAL_FEE }: AboutLabPricingProps) {
    return (
        <Stack p="lg" gap="lg">
            <Flex justify="left">
                <Avatar.Group spacing="md">
                    {clinicians.map((clinician) => (
                        <Avatar key={clinician.alt} src={clinician.src.src} alt={clinician.alt} size={80} />
                    ))}
                </Avatar.Group>
            </Flex>

            <Stack gap="md">
                <Text fz="xl" fw={500} c="gray.9">
                    About clinical reviews for lab tests
                </Text>
                <Text fz="md" c="gray.9">
                    A licensed clinician looks over your lab order and reviews your results once they&apos;re ready. If
                    anything looks concerning, they&apos;ll reach out with guidance on what to do next. After you get
                    your results, you can also book a visit to take next steps, like prescriptions, additional tests, or
                    referrals.
                </Text>
                <Text fz="md" c="gray.9">
                    Clinical review for labs is ${formatPrice(clinicalFee, 0)} and added at checkout. Not covered by
                    insurance. FSA and HSA eligible.
                </Text>
            </Stack>

            <Button fullWidth size="lg" radius="xl" onClick={onClose}>
                Got it
            </Button>
        </Stack>
    )
}
